import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Spinner from './Spinner';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  // Still fetching user info
  if (loading) return <Spinner />;

  // Not logged in → redirect to login
  if (!user) return <Navigate to="/login" replace />;

  // Logged in → render children
  return children;
};

export default PrivateRoute;
